import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from 'vue';
import { CompanyUserFormData } from '@/composables/useUser';
import {
  Department,
  DepartmentTreeNode,
} from '@/interfaces/model/general/department';
import DepartmentTreeSelect from '@/components/DepartmentTreeSelect.vue';
import { formatPhoneNumber, parsePhone } from '@/lib/formatter';
import { getRoleList } from '@/lib/formItem';
import { RoleId } from '@/lib/enum';
import { usePermissionComposable } from '@/composables/usePermission';
import {
  required,
  phoneNumber,
  isPositionName,
  hasNoComma,
  isRightEmailAddress,
} from '@/lib/rule';
import { VForm } from 'vuetify/lib/components';
import { useCompanyFeatureComposable } from '@/composables/useCompanyFeatures';
import { defineMessages } from '@/lib/i18n';
import sharedMessages from '@/lib/shared-messages';


export default /*#__PURE__*/_defineComponent({
  __name: 'CompanyUserForm',
  props: {
    isEdit: { type: Boolean },
    isMe: { type: Boolean },
    userForm: null,
    selectableDepartments: null,
    departmentTree: null
  },
  emits: ["update:isValidForm", "update:userForm"],
  setup(__props: any, { expose, emit: emits }: { emit: ({
  (e: 'update:isValidForm', data: boolean): void;
  (e: 'update:userForm', data: CompanyUserFormData): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  isEdit?: boolean;
  isMe?: boolean;
  userForm: CompanyUserFormData;
  selectableDepartments: Department[];
  departmentTree: DepartmentTreeNode[];
};

const m = defineMessages({
  checkSelectedRoleDetails: '選択中の権限詳細を確認',
  userRoleManagement: 'ユーザー権限管理',
});




const { isFeatureActive, COMPANY_FEATURES, generateInactiveMessage } =
  useCompanyFeatureComposable();
const { ROLE_PERMISSIONS_DESCRIPTION } = usePermissionComposable();

const form = ref<InstanceType<typeof VForm> | null>(null);
const isValidForm = ref<boolean>(false);
const localUserForm = ref<CompanyUserFormData>({ ...props.userForm });

const validate = () => {
  form.value?.validate();
};
const resetValidation = () => {
  form.value?.resetValidation();
};
const updateIsValidForm = (e: boolean) => {
  emits('update:isValidForm', e);
};

const updateSelectedDepartments = (uuids: string[]) => {
  localUserForm.value.departments = uuids
    .map((uuid) => props.selectableDepartments.find((d) => d.uuid === uuid))
    .filter((d): d is Department => d !== undefined);
};

watch(
  () => props.userForm,
  (newVal) => {
    localUserForm.value = { ...newVal };
  },
  { deep: true }
);

watch(
  localUserForm,
  (newVal) => {
    emits('update:userForm', { ...newVal });
  },
  { deep: true }
);

expose({
  validate,
  resetValidation,
});

return { __sfc: true,m, props, emits, isFeatureActive, COMPANY_FEATURES, generateInactiveMessage, ROLE_PERMISSIONS_DESCRIPTION, form, isValidForm, localUserForm, validate, resetValidation, updateIsValidForm, updateSelectedDepartments, DepartmentTreeSelect, formatPhoneNumber, parsePhone, getRoleList, RoleId, required, phoneNumber, isPositionName, hasNoComma, isRightEmailAddress, VForm, sharedMessages }
}

})